
/**
 * @fileoverview Brings heightened visibility to highly popular assets.
 * @author dburke2@gannett.com (David Burke)
 *
 */

define('modules/fronts/local-discovery-teaser',[
    'jquery',
    'underscore',
    'baseview',
    'user-manager',
    'utils'
],
function(
    $,
    _,
    BaseView,
    UserManager,
    Utils
) {

    "use strict";

    /**
     * View class.
     */
    var LocalDiscoveryTeaser = BaseView.extend({

        /**
         * Initialize the view.
         */
        initialize: function(options) {
            this._updateSidebarLinks();

            BaseView.prototype.initialize.call(this, options);
        },

        /**
         * Sets the href for all sidebar links based on the the user's login state
         * @private
         */
        _updateSidebarLinks: function() {
            UserManager.getAccount('firefly').getUserInfo().always(_.bind(function(userInfo) {
                $('.ldtsm-item').each(function () {
                    var href = $(this).attr('data-href');

                    if (userInfo === 'Not logged in.' && $(this).hasClass('ldtsm-login-required')) {
                        var successUrl = encodeURIComponent(href);
                        href = Utils.getNested(window.site_vars, "gup", "gupui_path") + '/' + window.site_vars.site_code + '-GUP-SAM/authenticate/?success-url=' + successUrl;
                    }

                    $(this).attr('href', href);
                });
            }, this));
        }
    });

    return LocalDiscoveryTeaser;
});
